/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from "prop-types";
import { format } from "date-fns";
import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

const CalendarWeekDayColumn = ({
	courses,
	date,
	eventComp: Course
}) => {
	// eslint-disable-next-line no-unused-vars
	const [searchParams, setSearchParams] = useSearchParams();
	const handleDrillDown = useCallback(() => {
		setSearchParams({
			date: format(date, "yyyy-MM-dd"),
			view: "day"
		});
	});

	return (
		<div className="day-column flex-fill">
			<div className="rbc-date-cell">
				<button className="rbc-button-link" onClick={handleDrillDown} type="button">
					{format(date, "dd")}
				</button>
			</div>
			{courses ? courses.map((event) => (
				<div className="rbc-event" key={event.id}>
					<Course event={event} />
				</div>)) : null}
		</div>
	);
};

CalendarWeekDayColumn.propTypes = {
	courses: PropTypes.arrayOf(PropTypes.shape({
		title: PropTypes.string
	})),
	date: PropTypes.instanceOf(Date).isRequired,
	eventComp: PropTypes.func.isRequired
};

CalendarWeekDayColumn.defaultProps = {
	courses: []
};

export default CalendarWeekDayColumn;
